import { createElement } from 'preact';

/**
 * テキスト内のURLを検出してクリック可能なリンクに変換する
 */
export function linkifyText(text?: string | null) {
  // 受信イベントによって text が undefined/null のことがあるため防御
  const safeText = typeof text === 'string' ? text : '';
  // URLを検出する正規表現
  const urlRegex = /(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/g;
  
  const parts: any[] = [];
  let lastIndex = 0;
  let match;
  let keyCounter = 0;

  while ((match = urlRegex.exec(safeText)) !== null) {
    // URLの前のテキスト
    if (match.index > lastIndex) {
      parts.push(safeText.substring(lastIndex, match.index));
    }

    // URLをリンクに変換
    const url = match[0];
    parts.push(
      createElement('a', {
        key: `link-${keyCounter++}`,
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer',
        style: {
          color: 'inherit',
          textDecoration: 'underline',
          fontWeight: '500',
          cursor: 'pointer'
        },
        onClick: (e: Event) => {
          e.stopPropagation();
        }
      }, url)
    );

    lastIndex = match.index + url.length;
  }

  // 残りのテキスト
  if (lastIndex < safeText.length) {
    parts.push(safeText.substring(lastIndex));
  }

  return parts.length > 0 ? parts : [safeText];
}

